import React from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { CarModel } from 'models/StockModel';


const freeDays = 30;

type OverstayProps = {
    car: CarModel,
    withTitle?: boolean,
}

const Overstay = ({car, withTitle}: OverstayProps) => {
    const {t} = useTranslation('cars');
    if (!car.yard?.dateIn)
        return null;

    const checkDate = car.voyage?.departedAt ? DateTime.fromISO(car.voyage.departedAt) : DateTime.now();

    const diff = checkDate
        .minus({ days: freeDays })
        .diff(DateTime.fromISO(car.yard.dateIn), 'days')
        .toObject();

    const days = Math.floor(diff.days || 0);

    if (days < 1)
        return null;

    if (withTitle)
        return (
            <>
                ({t('overstay')}: {days} {t('days')})
            </>
        )

    return (
        <>
            {days}
        </>
    );
};

export default Overstay;
